var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c(
        "div",
        {
          staticClass: "mfa-overlay",
          attrs: {
            id: _vm.id,
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.id + "-title",
            "aria-describedby": _vm.id + "-description",
          },
        },
        [
          _c("div", { staticClass: "mfa-backdrop" }),
          _vm._v(" "),
          _c("div", { staticClass: "mfa-dialog" }, [
            _c("div", { staticClass: "mfa-header" }, [
              _c(
                "h2",
                { staticClass: "mfa-title", attrs: { id: _vm.id + "-title" } },
                [_vm._v("Enter Verification Code")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "mfa-close",
                  attrs: { type: "button", "aria-label": "Close dialog" },
                  on: { click: _vm.close },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none",
                        "aria-hidden": "true",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M2 2l12 12M14 2L2 14",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mfa-body" }, [
              _c(
                "p",
                {
                  staticClass: "mfa-description",
                  attrs: { id: _vm.id + "-description" },
                },
                [_vm._v(_vm._s(_vm.description))]
              ),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "mfa-form",
                  attrs: { novalidate: "" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "mfa-field" }, [
                    _c(
                      "label",
                      {
                        staticClass: "mfa-label",
                        attrs: { for: _vm.id + "-input" },
                      },
                      [_vm._v("Verification code")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.code,
                          expression: "code",
                        },
                      ],
                      ref: "codeInput",
                      staticClass: "mfa-input",
                      class: {
                        "is-filled": _vm.code,
                        "is-error": _vm.hasError,
                      },
                      attrs: {
                        type: "text",
                        inputmode: "text",
                        pattern: "[A-Z0-9]",
                        maxlength: _vm.codeLength,
                        autocomplete: "off",
                        "aria-label": "Code input",
                        id: _vm.id + "-input",
                      },
                      domProps: { value: _vm.code },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.code = $event.target.value
                          },
                          function ($event) {
                            return _vm.onInput()
                          },
                        ],
                        paste: function ($event) {
                          $event.preventDefault()
                          return _vm.onPaste($event)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.hasError
                      ? _c(
                          "p",
                          {
                            staticClass: "mfa-error",
                            attrs: {
                              id: _vm.id + "-error",
                              role: "alert",
                              "aria-live": "polite",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.errorMessage) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.expiryText
                    ? _c("p", { staticClass: "mfa-description" }, [
                        _vm._v(_vm._s(_vm.expiryText)),
                      ])
                    : _vm._e(),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mfa-footer" }, [
              _vm.showResend
                ? _c(
                    "button",
                    {
                      staticClass: "mfa-btn mfa-btn--resend",
                      class: { "is-loading": _vm.isResending },
                      attrs: {
                        type: "button",
                        disabled: _vm.isResending || _vm.resendBlocked,
                      },
                      on: { click: _vm.resend },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.resendBlocked
                              ? "Resend Code (" + _vm.resendCountdown + "s)"
                              : "Resend Code"
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "mfa-btn mfa-btn--primary",
                  class: { "is-loading": _vm.isLoading },
                  attrs: {
                    type: "button",
                    disabled: _vm.isLoading || !_vm.isComplete,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("\n        Verify\n      ")]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }